import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'geoFences';
const BASE_PATH = `${API_ROOT}/geoFences`;
const PATHS = {
    CREATE: BASE_PATH,
    DELETE: (geoFenceId) => `${BASE_PATH}/${geoFenceId}`,
    GET: (geoFenceId) => `${BASE_PATH}/${geoFenceId}`,
    LIST: BASE_PATH,
    UPDATE: (geoFenceId) => `${BASE_PATH}/${geoFenceId}`,
};
async function create(csrfToken, props) {
    return (await (await SecureAxios()).post(PATHS.CREATE, { ...props }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function delete_(csrfToken, geoFenceId) {
    return (await (await SecureAxios()).delete(PATHS.DELETE(geoFenceId), { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function get(geoFenceId, props) {
    const params = new URLSearchParams();
    if (props?.preload)
        params.append('preload', props.preload.join(','));
    return (await (await SecureAxios()).get(`${PATHS.GET(geoFenceId)}?${params.toString()}`)).data;
}
function getKey(geoFenceId, props) {
    return [CacheKey, 'get', geoFenceId, props];
}
async function list(missionId, props) {
    const params = new URLSearchParams();
    params.append('missionId', missionId);
    if (props.limit)
        params.append('limit', props.limit.toString());
    if (props.offset)
        params.append('offset', props.offset.toString());
    if (props.orderBy)
        params.append('orderBy', props.orderBy);
    if (props.order)
        params.append('order', props.order);
    if (props.query)
        params.append('q', props.query);
    return (await (await SecureAxios()).get(`${PATHS.LIST}?${params.toString()}`)).data;
}
function listKey(missionId, props) {
    return [CacheKey, 'list', missionId, props];
}
async function update(csrfToken, geoFenceId, props) {
    return (await (await SecureAxios()).put(PATHS.UPDATE(geoFenceId), { ...props }, { headers: { 'X-CSRF-Token': csrfToken } }))
        .data;
}
export default { CacheKey, create, delete_, get, getKey, list, listKey, update };
